import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pregunta-opciones',
  templateUrl: 'pregunta-opciones.html'
})
export class PreguntaOpcionesComponent {

  @Input() preguntaActual: any;
  @Input() respuestaActual: any;
  @Input() enEsperaRespuesta: boolean;
  @Output() handleRespuesta = new EventEmitter<any>();

  constructor() { }

  _handleRespuesta(opcion, index) {
    this.handleRespuesta.emit({opcion, index});
  }

}



// WEBPACK FOOTER //
// ./src/components/pregunta-opciones/pregunta-opciones.ts